import { useState } from 'react';
import axios from 'axios';

const TestScraping = () => {
  const [numeroRncp, setNumeroRncp] = useState('37537');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [results, setResults] = useState(null);

  const handleScrape = async () => {
    setLoading(true);
    setError(null);
    setResults(null);

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token non trouvé. Veuillez vous reconnecter.');
      }

      const response = await axios.post(
        'http://localhost:3002/api/rncp-scraping/scrape',
        { numeroRncp },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      setResults(response.data.data);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Test Scraping RNCP
          </h1>
          <p className="text-gray-600">
            Extraire les blocs de compétences et compétences détaillées depuis France Compétences
          </p>
        </div>

        {/* Formulaire */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <div className="flex items-end gap-4">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Code RNCP
              </label>
              <input
                type="text"
                value={numeroRncp}
                onChange={(e) => setNumeroRncp(e.target.value)}
                placeholder="Entrez le numéro RNCP (ex: 37537 ou RNCP37537)"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleScrape}
              disabled={loading || !numeroRncp}
              className={`px-6 py-2 rounded-lg font-medium transition-colors ${
                loading || !numeroRncp
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-blue-600 hover:bg-blue-700 text-white'
              }`}
            >
              {loading ? 'Scraping en cours...' : 'Lancer le scraping'}
            </button>
          </div>

          {/* Info */}
          <p className="mt-4 text-sm text-gray-500">
            💡 Exemple : CAP Boulanger = <strong>37537</strong>
          </p>
        </div>

        {/* Erreur */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">Erreur</h3>
                <p className="mt-1 text-sm text-red-700">{error}</p>
              </div>
            </div>
          </div>
        )}

        {/* Résultats */}
        {results && (
          <div className="space-y-6">
            {/* En-tête des résultats */}
            <div className="bg-green-50 border border-green-200 rounded-lg p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                {results.intitule}
              </h2>
              <p className="text-gray-600">
                Code RNCP : <span className="font-semibold">{results.numeroRncp}</span>
              </p>
              <p className="text-gray-600">
                Nombre de blocs : <span className="font-semibold">{results.blocsCompetences.length}</span>
              </p>
            </div>

            {/* Liste des blocs */}
            <div className="space-y-4">
              {results.blocsCompetences.map((bloc, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
                  {/* En-tête du bloc */}
                  <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4">
                    <h3 className="text-lg font-semibold text-white">
                      {bloc.code} - {bloc.libelle}
                    </h3>
                    <p className="text-blue-100 text-sm mt-1">
                      {bloc.competences.length} compétence{bloc.competences.length > 1 ? 's' : ''}
                    </p>
                  </div>

                  {/* Liste des compétences */}
                  <div className="px-6 py-4">
                    {bloc.competences.length > 0 ? (
                      <ul className="space-y-2">
                        {bloc.competences.map((competence, compIndex) => (
                          <li key={compIndex} className="flex items-start">
                            <span className="inline-flex items-center justify-center w-6 h-6 mr-3 text-xs font-medium text-blue-600 bg-blue-100 rounded-full flex-shrink-0 mt-0.5">
                              {compIndex + 1}
                            </span>
                            <span className="text-gray-700 flex-1">
                              {competence}
                            </span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-gray-500 italic">
                        Aucune compétence trouvée pour ce bloc
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Récapitulatif */}
            <div className="bg-gray-100 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Récapitulatif
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-600">Total de blocs</p>
                  <p className="text-2xl font-bold text-blue-600">
                    {results.blocsCompetences.length}
                  </p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-600">Total de compétences</p>
                  <p className="text-2xl font-bold text-green-600">
                    {results.blocsCompetences.reduce((total, bloc) => total + bloc.competences.length, 0)}
                  </p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-600">Moyenne par bloc</p>
                  <p className="text-2xl font-bold text-purple-600">
                    {(results.blocsCompetences.reduce((total, bloc) => total + bloc.competences.length, 0) / results.blocsCompetences.length).toFixed(1)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Zone vide */}
        {!loading && !error && !results && (
          <div className="bg-white rounded-lg shadow-md p-12 text-center">
            <svg className="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Aucun résultat
            </h3>
            <p className="text-gray-600">
              Entrez un code RNCP et lancez le scraping pour voir les résultats
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestScraping;
